import { render, staticRenderFns } from "./EventRow.vue?vue&type=template&id=38f28aba&"
import script from "./EventRow.vue?vue&type=script&lang=js&"
export * from "./EventRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports